var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1192_465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1192_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5H9",
    stroke: "#8C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1L9 5L5 9",
    stroke: "#8C8E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMicro);
export default __webpack_public_path__ + "static/media/arrow_micro.02c092dde5fe0bb4c50703caad59391c.svg";
export { ForwardRef as ReactComponent };